const MachineCategories = () => import('./_views/machineCategories');

export default [
  {
    path: '/additional/machine-categories',
    name: 'machineCategories',
    component: MachineCategories,
    meta: {
      title: 'Machine Categories',
      group: 'additional',
      navigation: {
        position: 3,
        name: 'Machine Categories',
        specialQueries: ['suffix'],
        to: {
          name: 'machineCategories',
          query: {
            suffix: '',
          },
        },
      },
    },
  },
];
